export const COURSES_QUERY_KEY = 'courses';
export const COURSE_QUERY_KEY = 'course';
export const COURSE_DESKTOPS_QUERY_KEY = 'courseDesktops';
export const COURSE_PARTICIPANTS_QUERY_KEY = 'courseParticipants';
export const COURSE_FOR_EDIT_QUERY_KEY = 'courseForEdit';
export const COURSE_JOIN_CODE_QUERY_KEY = 'courseJoinCode';
export const COURSE_TRAINER_INVITATIONS_QUERY_KEY = 'courseTrainerInvitations';
export const MY_DESKTOP_QUERY_KEY = 'myDesktop';
export const TRAINER_DESKTOP_QUERY_KEY = 'trainerDesktop';
export const FRESH_START_DESKTOP_QUERY_KEY = 'freshStartDesktop';
export const FRESH_START_SERVERS_QUERY_KEY = 'freshStartServers';
export const OS_TEMPLATES_QUERY_KEY = 'osTemplates';
export const STANDALONES_QUERY_KEY = 'standalones';
export const ORGANIZATION_TRAINERS_BY_DADESKTOP_QUERY_KEY = 'organizationTrainersByDaDesktopId';

export const COURSE_TAGS_QUERY_KEY = ['courses', 'tags'] as const;
export const TEST_COURSE_QUERY_KEY = 'testCourse';
